<template>
  <div style="margin: 1rem; padding: 1rem; width: 21rem;" class="bg-modal" @click.stop>
    <div class="row gap-04">
      <text-item txt="Favoris" class="pad-m w-maxC" styles="font-l main-h"/>
      <svg-item :icon="props.bioIcon" styles="size-l main-m"/>
    </div>
    <template v-if="appUserStore.currentAppUserData">
      <div class="mtop-04"></div>
      <inputBox>
        <inputAreaAuto2 :lines=20 v-model="preferenceText" @blur="updatePreferenceText()"/>
      </inputBox>
    </template>
  </div>
</template>




<script setup>
import { ref, watch } from 'vue';
import appuserapi from '@/api/appuserapi';
import { useAppUserStore } from '@/stores/appUser';

const appUserStore = useAppUserStore()
const preferenceText = ref("")

const props = defineProps({
  bioKey: {
    type: String,
    required: true,
  },
  bioIcon: {
    type: String,
    required: true,
  },  
})

async function updatePreferenceText() {
  if (!appUserStore.currentAppUserData) return
  const oldText = getPreferenceText()
  const newText = preferenceText.value
  if (oldText === newText) return

  const key = "Bp" + props.bioKey.charAt(0).toUpperCase() + props.bioKey.slice(1)
  await appuserapi.updateReferenceText(key, newText)
  await appUserStore.setCurrentAppUserData()
}

function setPreferenceText() {
  if (!appUserStore.currentAppUserData) return
  preferenceText.value = getPreferenceText()
}

function getPreferenceText() {
  const bioPrescriptions = appUserStore.currentAppUserData.preferences.bioPrescriptions
  return bioPrescriptions[props.bioKey].referenceText
}


watch(
  () => appUserStore.currentAppUserData,
  () => {setPreferenceText()},
  { immediate: true }
)

</script>

<style scoped>
</style>